<template>
  <div>
    <el-drawer
      :visible.sync="disableShow"
      v-if="disableShow"
      size="100%"
      direction="rtl"
      :wrapperClosable="false"
      :title="'k线梯度配置【' + (this.orderDirection ? '多' : '空') + '】-'+this.form.platform">
      <el-form :model="form" :inline="true" size="small" label-position="top" ref="form" label-width="120px" :show-message="false">
      <!-- 动态渲染的表单项 -->
        <div v-for="(item, index) in form.levels" :key="index" class="form-item-row form-area">
          <div style="display: flex; justify-content: space-between; border-bottom: 1px solid #DCDFE6">
            <div>梯度{{(index + 1)}}
              <span style="color: #07bd54; font-size: 14px">{{computIncome(item)}}</span>
              <span style="color: #f56c6c; font-size: 14px"> {{computLoss(item)}}</span>
            </div>
            <el-button type="danger" size="mini" circle @click="removeItem(index)">
              <i class="el-icon-close"></i>
            </el-button>
          </div>
          <div style="display: flex; justify-content: space-between;">
            <div>
              <div>
                <el-form-item
                  class="form-item-line"
                  :label="'触发梯度'"
                  :prop="'levels.' + index + '.rate_level'"
                  :rules="{ required: true, message: '触发百分比为空', trigger: 'blur' }"
                >
                  <el-input v-model="item.rate_level" type="number" placeholder="例：15"></el-input>
                </el-form-item>
                <el-form-item
                  class="form-item-line"
                  :label="'下单倍数'"
                  :prop="'levels.' + index + '.order_lever'"
                  :rules="{ required: true, message: '下单倍数为空', trigger: 'blur' }"
                >
                  <el-input v-model="item.order_lever" type="number" placeholder="例如：5"></el-input>
                </el-form-item>
                <el-form-item
                  class="form-item-line"
                  :label="'下单金额'"
                  :prop="'levels.' + index + '.order_amount'"
                  :rules="{ required: true, message: '下单金额为空', trigger: 'blur' }"
                >
                  <el-input v-model="item.order_amount" type="number" placeholder="例如：50"></el-input>
                </el-form-item>
              </div>
              <div>
                <el-form-item
                  class="form-item-line"
                  :label="'k线根数'"
                  :prop="'levels.' + index + '.k_limit'"
                  :rules="{ required: true, message: '下单金额为空', trigger: 'blur' }"
                >
                  <el-input v-model="item.k_limit" type="number" placeholder="例如：5"></el-input>
                </el-form-item>
                <el-form-item
                  class="form-item-line"
                  :label="'止盈点数'"
                  :prop="'levels.' + index + '.profit_percentage'"
                  :rules="{ required: true, message: '止盈点数为空', trigger: 'blur' }"
                >
                  <el-input v-model="item.profit_percentage" type="number" placeholder="例：5"></el-input>
                </el-form-item>
                <el-form-item
                  class="form-item-line"
                  :label="'止损点数'"
                  :prop="'levels.' + index + '.loss_percentage'"
                >
                  <el-input v-model="item.loss_percentage" type="number" placeholder="例：5"></el-input>
                </el-form-item>
              </div>
              <div>
                <el-form-item
                  class="form-item-line"
                  :label="'是否启用'"
                  :prop="'levels.' + index + '.is_enable'"
                >
                  <el-switch v-model="item.is_enable">
                  </el-switch>
                </el-form-item>
                <el-form-item
                  class="form-item-line"
                  :label="'仅通知不下单'"
                  :prop="'levels.' + index + '.is_only_notice'"
                >
                  <el-switch v-model="item.is_only_notice">
                  </el-switch>
                </el-form-item>
              </div>
            </div>
            <div style="display: flex; align-items: center;">
              <el-button type="primary" size="mini" circle @click="addItem(index)">
                <i class="el-icon-circle-plus-outline"></i>
              </el-button>
            </div>
          </div>
        </div>

        <!-- 添加按钮 -->
        <div style="display: flex;justify-content: space-around;">
          <el-button @click="onCancel">取消</el-button>
          <el-button type="primary" @click="onSubmit">提交</el-button>
        </div>
      </el-form>
    </el-drawer>
  </div>
</template>

<script>
import api from '@/api/api'

const defaultForm = {
  rate_level: '',
  order_lever: '',
  order_amount: '',
  k_limit: '',
  profit_percentage: '',
  loss_percentage: 0,
  is_enable: true,
  is_only_notice: false
}

export default {
  name: 'GlobbingConfigSave',
  props: {
    orderDirection: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      disableShow: false,
      nowPrice: 1,
      platform: '',
      form: {
        levels: [],
        platform: ''
      }
    }
  },
  methods: {
    computIncome (item) {
      if (parseFloat(item.order_lever) > 0 && parseFloat(item.order_amount) > 0 && parseFloat(item.profit_percentage)) {
        return `预估收益：${item.order_lever * item.order_amount * item.profit_percentage * 0.01}`
      }
      return ''
    },
    computLoss (item) {
      if (parseFloat(item.order_lever) > 0 && parseFloat(item.order_amount) > 0 && parseFloat(item.loss_percentage)) {
        if (parseFloat(item.order_lever) * parseFloat(item.loss_percentage) >= 100) {
          return '止损亏损：已超爆仓阈值！'
        }
        return `止损亏损：${item.order_lever * item.order_amount * item.loss_percentage * 0.01}`
      }
      return ''
    },
    // 添加新行
    addItem (idx) {
      this.form.levels.splice(idx + 1, 0, { ...defaultForm })
    },
    // 删除行
    removeItem (index) {
      if (this.form.levels.length === 1) {
        this.$message.error('至少保留一个配置表单')
        return false
      }
      this.form.levels.splice(index, 1)
    },
    onCancel () {
      this.disableShow = false
      this.$emit('successfn')
    },
    onSubmit () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$loading({ body: true })
          const levels = this.form.levels.map(item => {
            return {
              is_only_notice: item.is_only_notice ? 1 : 0,
              is_enable: item.is_enable ? 1 : 0,
              rate_level: parseFloat(item.rate_level),
              order_lever: parseInt(item.order_lever),
              k_limit: parseInt(item.k_limit),
              order_amount: parseFloat(item.order_amount),
              profit_percentage: parseFloat(item.profit_percentage),
              loss_percentage: parseFloat(item.loss_percentage)
            }
          })
          const params = {
            platform: this.form.platform,
            order_direction: this.orderDirection,
            levels: JSON.stringify(levels)
          }
          api.globbingConfigSave(params).then(res => {
            console.log(res)
            if (res.code === 0) {
              this.$message.success({
                message: '操作成功',
                customClass: 'phone-custom-message'
              })
              this.disableShow = false
            } else if (res.code === 20001) {
              this.$message.warning({
                message: res.message,
                customClass: 'phone-custom-message'
              })
              this.disableShow = false
            } else {
              this.$message.error({
                message: res.message,
                customClass: 'phone-custom-message'
              })
            }
          }).catch(res => {
            this.$message.error({
              message: res,
              customClass: 'phone-custom-message'
            })
          }).finally(() => {
            this.$loading({}).close()
            this.$emit('successfn')
          })
        } else {
          return false
        }
      })
    },
    async show ({ platform, levels }) {
      this.form.platform = platform
      this.$loading({ body: true })
      // 获取可选货币列表
      this.disableShow = true
      if (levels && levels.length > 0) {
        // 编辑回显
        this.form.levels = levels.map(item => {
          item.is_only_notice = !!item.is_only_notice
          item.is_enable = !!item.is_enable
          return item
        })
      } else {
        // 新建使用默认值
        this.form.levels = [{ ...defaultForm }]
      }
      this.$loading({}).close()
    }
  }
}
</script>

<style scoped>
.tradeConfigForm {
  padding-right: 15px;;
}
.tradeConfigForm .el-form-item {
  margin-bottom: 10px;
}
.trigger-level-form {
  padding-top: 5px;
}
.form-area {
  border: 1px solid #DCDFE6;
  border-radius: 4px;
  margin: 10px;
  padding: 5px;
}
.form-item-line {
  width: 100px;
}
::v-deep .el-form-item__label {
  padding: 0;
}
::v-deep .el-form-item {
  margin-bottom: 0;
}
::v-deep .el-drawer__header {
  margin-bottom: 10px;
}

</style>
<style>
.U-append .el-input-group__append {
  padding-left: 8px !important;
  padding-right: 8px !important;
}
.phone-custom-message {
  top: 30% !important; /* 垂直居中 */
  left: 50% !important; /* 水平居中 */
  transform: translate(-50%, -50%) !important; /* 偏移修正 */
  width: auto !important; /* 宽度自适应 */
  min-width: 200px; /* 最小宽度 */
  text-align: center; /* 文字居中 */
}
</style>
